<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <div class="ql-editor" v-html="content"></div>
      </div>
      <!--<div class="wrap">-->
        <!--<img src="@/assets/images/MuseumAffairs06@2x.png" alt="">-->
        <!--<div class="ql-editor">-->
          <!--<p class="ql-align-justify">举重是我国的优势体育项目，新中国成立后，我国举重竞技水平不断提高，进入了世界先进行列。截至2023年12月，中国举重健儿已先后收获39枚奥运会金牌、588枚世锦赛金牌，创破各层次世界纪录超1000次，占世界各国或地区创造世界纪录总数的五分之一。为弘扬中国举重精神，由国家体育总局举重摔跤柔道运动管理中心、中国举重协会和东莞市人民政府三方共建的我国唯一一座全面展示中国举重运动发展及辉煌成就的国家级专题博物馆——中国举重博物馆，在2024年落成启用。</p>-->
          <!--<p class="ql-align-justify">&nbsp;</p>-->
          <!--<p class="ql-align-justify">中国举重博物馆，坐落于曾哺育出新中国第一个打破世界纪录的陈镜开、夺得第一枚奥运举重金牌的曾国强等一大批享誉世界举坛运动员的著名“举重之乡”——东莞石龙。场馆以新旧融合为设计理念，主体建筑既有新建馆体，亦完整保留70年代石龙老体校。场馆总建筑面积14000余平方米，馆藏品6000余件，馆内通过图文、实物展示以及沉浸式互动体验等方式，展示中国举重运动发展、传播中国举重文化、弘扬举重精神，是促进中外体育交流的重要平台和窗口。 </p>-->
          <!--<img src="@/assets/images/MuseumAffairs05@2x.png" alt="">-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getSingle} from "@/api";
  import {mixin} from '@/mixin/index.js';
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import Breadcrumb from "@/common/Breadcrumb";

  export default {
    name: "A1",
    mixins :  [mixin],
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      Breadcrumb
    },
    data(){
      return{
        // 富文本内容
        content :''
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        this.getData()
      }
    },
    created() {
      this.getData()
    },
    methods:{
      async getData() {
        let {data: {rows}} = await getSingle({
          pageNum: 1,
          pageSize: 10,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: "本馆概况",
          articleKey:'cms'
        })
        rows[0].articleContent = this.updateImageUrl(rows[0].articleContent)
        this.content = rows[0].articleContent
      },
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6;
  }
  .container{
    padding-bottom: 100px;
  }
  .wrap {
    width: 1210px;
    margin: 0 auto;
    overflow: hidden;

    >img:nth-of-type(1) {
      display: block;
      margin: 0 auto 48px;
    }

    p {
      font-family: Source Han Sans CN;
      font-size: 24px;
      color: #666666;
      line-height: 48px;

      span {
        color: #222;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MuseumAffairs/A1/A1.vue